import router from '@/router';
import { MessagePlugin } from 'tdesign-vue-next';

// 动态路由映射表
const componentMap = {
  'views/dashboard/index': () => import('@/views/dashboard/index.vue'),
  'views/home/index': () => import('@/views/home/index.vue'),
  'views/profile/index': () => import('@/views/profile/index.vue'),
  'views/express/index': () => import('@/views/express/index.vue'),
  
  // 账号管理
  'views/account/index': () => import('@/views/dashboard/index.vue'),
  'views/account/tiktok': () => import('@/views/account/tiktok.vue'),
  
  // 设备管理
  'views/devices/index': () => import('@/views/dashboard/index.vue'),
  'views/devices/adspower-list': () => import('@/views/devices/adspower-list.vue'),
  'views/account/adspower-list': () => import('@/views/devices/adspower-list.vue'),
  
  // 样品管理
  'views/product/index': () => import('@/views/dashboard/index.vue'),
  'views/product/list': () => import('@/views/product/list.vue'),
  'views/product/history': () => import('@/views/product/history.vue'),
  'views/product/fulfillment': () => import('@/views/product/fulfillment.vue'),
  'views/product/affiliate-list': () => import('@/views/product/affiliate-list.vue'),
  'views/product/tap-global-products': () => import('@/views/product/tap-global-products.vue'),
  'views/product/selected-products-list': () => import('@/views/product/selected-products-list.vue'),
  'views/product/affiliate-product-list': () => import('@/views/product/affiliate-product-list.vue'),
  
  // 团队管理
  'views/team/list': () => import('@/views/team/list.vue'),
  'views/team/members': () => import('@/views/team/members.vue'),
  'views/team/user-permission': () => import('@/views/team/user-permission.vue'),
  
  // 数据统计
  'views/statistics/index': () => import('@/views/dashboard/index.vue'),
  'views/statistics/tiktok': () => import('@/views/statistics/tiktok.vue'),
  'views/statistics/product': () => import('@/views/statistics/product.vue'),
  'views/statistics/ads-link': () => import('@/views/statistics/ads-link.vue'),
  'views/statistics/tap-order-statistics': () => import('@/views/statistics/tap-order-statistics.vue'),
  'views/statistics/tap-key-metrics': () => import('@/views/statistics/tap-key-metrics.vue'),
  'views/statistics/tap-play-products': () => import('@/views/statistics/tap-play-products.vue'),
  'views/statistics/analytics': () => import('@/views/statistics/analytics.vue'),

  // 全域数据探索
  'views/data-explorer/index': () => import('@/views/dashboard/index.vue'),
  'views/data-explorer/query': () => import('@/views/data-explorer/query.vue'),
  
  // 快捷中心
  'views/shortcuts/index': () => import('@/views/dashboard/index.vue'),
  'views/shortcuts/blue_cart': () => import('@/views/shortcuts/blue_cart.vue'),
  'views/shortcuts/excel_analysis': () => import('@/views/shortcuts/excel-analysis.vue'),
  'views/shortcuts/excel-analysis': () => import('@/views/shortcuts/excel-analysis.vue'),
  
  // 素材中心/资源中心
  'views/material/index': () => import('@/views/dashboard/index.vue'),
  'views/material/hot-tags': () => import('@/views/material/hot-tags.vue'),
  'views/material/copy-center': () => import('@/views/material/copy-center.vue'),
  'views/material/proxy-manage': () => import('@/views/material/proxy-manage.vue'),
  'views/material/product-image': () => import('@/views/material/product-image.vue'),
  
  // AI创意工坊
  'views/ai-workshop/index': () => import('@/views/dashboard/index.vue'),
  'views/ai-workshop/ai-copy': () => import('@/views/ai-workshop/ai-copy.vue'),
  'views/ai-workshop/ai-video': () => import('@/views/ai-workshop/ai-video.vue'),
  'views/ai-workshop/ai-image': () => import('@/views/ai-workshop/ai-image.vue'),
  'views/ai-workshop/video-workflow': () => import('@/views/ai-workshop/video-workflow.vue'),
  'views/ai-workshop/prompt-center': () => import('@/views/ai-workshop/prompt-center.vue'),
  'views/ai-workshop/ai-model-profile': () => import('@/views/ai-workshop/ai-model-profile.vue'),
  'views/ai-workshop/ai-content-lab': () => import('@/views/ai-workshop/ai-content-lab.vue'),
  'views/ai-workshop/viral-video-recreation': () => import('@/views/ai-workshop/viral-video-recreation.vue'),
  
  // 任务广场
  'views/task-center/index': () => import('@/views/dashboard/index.vue'),
  'views/task-center/publish-task': () => import('@/views/task-center/publish-task.vue'),
  'views/task-center/new-publish-task': () => import('@/views/task-center/publish-task.vue'),
  'views/task-center/operation-task': () => import('@/views/task-center/operation-task.vue'),
  
  // 配置中心
  'views/settings-center/index': () => import('@/views/dashboard/index.vue'),
  'views/settings-center/ai-settings': () => import('@/views/settings-center/ai-settings.vue'),
  'views/settings-center/oss-settings': () => import('@/views/settings-center/oss-settings.vue'),
  'views/settings-center/external-service-settings': () => import('@/views/settings-center/external-service-settings.vue'),

  // 选品中心
  'views/product-selection/index': () => import('@/views/dashboard/index.vue'),
  'views/product-selection/high-growth': () => import('@/views/product-selection/high-growth.vue'),
  'views/product-selection/creator-hot-products': () => import('@/views/product-selection/creator-hot-products.vue'),
  'views/product-selection/product-pool': () => import('@/views/product-selection/product-pool.vue'),

  // 积分中心
  'views/point-center/index': () => import('@/views/dashboard/index.vue'),
  'views/point-center/point-detail': () => import('@/views/point-center/point-detail.vue'),
  'views/point-center/team-point-management': () => import('@/views/point-center/team-point-management.vue'),
};

// 图标映射表
const iconMap = {
  'home': 'home',
  'view-list': 'view-list',
  'shop': 'shop',
  'history': 'history',
  'user-list': 'user-list',
  'user-circle': 'user-circle',
  'send': 'send',
  'usergroup': 'usergroup',
  'alarm': 'alarm',
  'analytics': 'chart',
  'link': 'link',
  'mobile-shortcut': 'mobile-shortcut',
  'shop-3': 'shop',
  'chart-bubble': 'chart-bubble',
  'time': 'time',
  'video': 'video',
  'play-circle': 'play-circle',
  'browse': 'browse',
  'cart-add': 'cart-add',
  'cart': 'cart',
  'file-copy': 'file-copy',
  'mouse': 'mouse',
  'bulletpoint': 'bulletpoint',
  'add': 'add',
  'refresh': 'refresh',
  'user-business': 'user-business',
  'chart-line-data-1': 'chart-line-data-1',
  'center-focus-strong': 'layers',
  'tag': 'discount',
  'search': 'search',
  'trending-up': 'trending-up',
  'filter-3': 'filter',
  'folder': 'folder',
  'wallet': 'wallet',
  'chat-message': 'chat-message',
  'task-double': 'task-double',
  'task-checked': 'task-checked',
  'rocket': 'rocket',
};

// 处理后端返回的权限数据，生成路由配置
export function generateRoutes(permissions) {
  if (!permissions || !permissions.pages || !permissions.pages.length) {
    return [];
  }

  // 处理页面权限
  const routes = [];
  const dashboardRoute = {
    path: '/dashboard',
    name: 'Dashboard',
    component: componentMap['views/dashboard/index'],
    redirect: '/dashboard/home',
    meta: {
      title: '首页',
      requiresAuth: true
    },
    children: []
  };
  
  // 添加首页路由
  dashboardRoute.children.push({
    path: 'home',
    name: 'Home',
    component: () => import('@/views/home/index.vue'),
    meta: {
      title: '首页',
      requiresAuth: true
    }
  });
  
  // 创建权限代码映射，用于快速查找
  const permissionCodeMap = new Map();
  permissions.pages.forEach(page => {
    permissionCodeMap.set(page.code, page);
  });
  
  // 处理权限页面 - 支持树形结构
  permissions.pages.forEach(page => {
    // 检查组件是否存在
    if (!componentMap[page.component]) {
      console.warn(`组件 ${page.component} 不存在`);
      return;
    }
    
    // 将路径转换为 /dashboard 下的路由
    let fullPath = page.path.startsWith('/dashboard') ? page.path : `/dashboard${page.path}`;
    
    // 特殊处理个人中心路径
    if (page.code === 'UserProfile' && page.path === '/profile') {
      fullPath = '/dashboard/profile';
    }
    
    // 创建路由对象
    const route = {
      path: fullPath,
      name: page.code,
      component: componentMap[page.component],
      meta: {
        title: page.name,
        icon: iconMap[page.icon] || page.icon,
        requiresAuth: true,
        sort: page.sort || 0
      }
    };
    
    // 如果有子菜单，处理子路由
    if (page.children && page.children.length > 0) {
      route.children = [];
      const firstChildPath = page.children[0].path.startsWith('/dashboard') 
        ? page.children[0].path 
        : `/dashboard${page.children[0].path}`;
      route.redirect = firstChildPath; // 重定向到第一个子菜单
      
      page.children.forEach(child => {
        if (componentMap[child.component]) {
          const childPath = child.path.split('/').pop(); // 提取路径的最后一部分作为子路由路径
          route.children.push({
            path: childPath,
            name: child.code,
            component: componentMap[child.component],
            meta: {
              title: child.name,
              icon: iconMap[child.icon] || child.icon,
              requiresAuth: true,
              sort: child.sort || 0,
              fullPath: child.path // 保存完整路径用于导航
            }
          });
        }
      });
    }
    
    // 如果是顶级路由，添加到routes数组
    if (page.path.split('/').length === 2 || page.code === 'UserProfile') {
      // 个人中心特殊处理：作为dashboard的子路由
      if (page.code === 'UserProfile') {
        dashboardRoute.children.push({
          path: 'profile',
          name: page.code,
          component: componentMap[page.component],
          meta: {
            title: page.name,
            icon: iconMap[page.icon] || page.icon,
            requiresAuth: true,
            sort: page.sort || 0
          }
        });
      } else {
        // 检查是否已经存在相同路径的路由
        const existingRouteIndex = routes.findIndex(r => r.path === fullPath);
        if (existingRouteIndex === -1) {
          // 如果不存在，添加新路由
          routes.push(route);
        }
      }
    } else {
      // 如果是子路由，添加到父路由的children数组
      const parentPath = fullPath.substring(0, fullPath.lastIndexOf('/'));
      let parentRoute = routes.find(r => r.path === parentPath);
      
      // 如果父路由不存在，创建一个
      if (!parentRoute) {
        // 尝试从权限中找到父级菜单
        const parentCode = page.path.split('/')[1].charAt(0).toUpperCase() + 
                          page.path.split('/')[1].slice(1);
        
        // 如果父级菜单不在权限中，使用默认配置
        parentRoute = {
          path: parentPath,
          name: parentCode,
          component: componentMap['views/dashboard/index'],
          redirect: fullPath,
          meta: {
            title: parentCode === 'Product' ? '样品管理' : 
                   parentCode === 'Team' ? '团队管理' : 
                   page.name.split('/')[0],
            requiresAuth: true
          },
          children: []
        };
        routes.push(parentRoute);
      }
      
      // 如果父路由没有children属性，添加一个
      if (!parentRoute.children) {
        parentRoute.children = [];
      }
      
      // 添加子路由
      parentRoute.children.push({
        path: fullPath.substring(parentPath.length + 1),
        name: page.code,
        component: componentMap[page.component],
        meta: {
          title: page.name,
          icon: iconMap[page.icon] || page.icon,
          requiresAuth: true,
          sort: page.sort || 0
        }
      });
    }
  });
  
  // 将所有路由添加到routes数组
  routes.push(dashboardRoute);
  
  return routes;
}

// 保存按钮权限
export function saveButtonPermissions(permissions) {
  if (permissions && permissions.buttons) {
    localStorage.setItem('button_permissions', JSON.stringify(permissions.buttons));
  }
}

// 检查按钮权限
export function hasButtonPermission(permission) {
  const buttonPermissions = JSON.parse(localStorage.getItem('button_permissions') || '[]');
  return buttonPermissions.includes(permission);
}

// 检查页面权限
export function hasPagePermission(pageName) {
  try {
    const userInfo = JSON.parse(localStorage.getItem('user_info') || '{}');
    const permissions = userInfo?.permissions?.pages || [];
    return permissions.some(page => page.code === pageName);
  } catch (error) {
    console.error('权限检查失败:', error);
    return false;
  }
}

// 检查用户是否是管理员或超级管理员
export function isAdminUser() {
  try {
    const userInfo = JSON.parse(localStorage.getItem('user_info') || '{}');
    const roleId = userInfo?.role_id;
    return roleId === 1 || roleId === 2; // 1=管理员, 2=超级管理员
  } catch (error) {
    console.error('角色检查失败:', error);
    return false;
  }
}

// 添加动态路由
export function addDynamicRoutes(routes) {
  try {
    console.log('开始添加动态路由，路由数量:', routes.length);
    console.log('路由详情:', routes);
    
    // 添加新的动态路由
    routes.forEach(route => {
      console.log('添加路由:', route.name, route.path);
      router.addRoute(route);
      
      // 如果有子路由，也打印出来
      if (route.children && route.children.length > 0) {
        route.children.forEach(child => {
          console.log('  - 子路由:', child.name, child.path);
        });
      }
    });
    
    // 添加404路由
    router.addRoute({
      path: '/:pathMatch(.*)*',
      redirect: '/dashboard/home'
    });
    
    console.log('路由添加完成，当前路由总数:', router.getRoutes().length);
    console.log('所有路由名称:', router.getRoutes().map(r => r.name));
    
    return true;
  } catch (error) {
    console.error('添加动态路由失败:', error);
    MessagePlugin.error('路由加载失败，请重新登录');
    return false;
  }
}

// 初始化权限
export function initPermission() {
  console.log('=== 开始初始化权限 ===');
  
  // 检查是否已经初始化过，避免重复操作
  const isInitialized = localStorage.getItem('routes_initialized');
  console.log('路由是否已初始化:', isInitialized);
  
  if (isInitialized === 'true') {
    // 检查路由是否存在，如果已经存在则直接返回true
    if (router.hasRoute('Dashboard') && router.hasRoute('Home')) {
      console.log('路由已存在，跳过初始化');
      return true;
    }
  }
  
  const userInfo = JSON.parse(localStorage.getItem('user_info') || '{}');
  console.log('用户信息:', userInfo);
  console.log('权限数据:', userInfo.permissions);
  
  if (userInfo && userInfo.permissions) {
    try {
      // 生成动态路由
      console.log('生成动态路由...');
      const routes = generateRoutes(userInfo.permissions);
      console.log('生成的路由:', routes);
      
      // 添加动态路由
      const result = addDynamicRoutes(routes);
      
      // 保存按钮权限
      saveButtonPermissions(userInfo.permissions);
      
      // 标记路由已初始化
      if (result) {
        localStorage.setItem('routes_initialized', 'true');
        console.log('=== 权限初始化成功 ===');
      }
      
      return result;
    } catch (error) {
      console.error('权限初始化失败:', error);
      return false;
    }
  }
  
  console.error('没有用户信息或权限数据');
  return false;
}

// 清除权限和路由
export function clearPermissions() {
  localStorage.removeItem('button_permissions');
  localStorage.removeItem('routes_initialized');
  localStorage.removeItem('current_team_id'); // 清除当前团队ID
  
  // 移除所有需要权限的路由
  router.getRoutes().forEach(route => {
    if (route.meta && route.meta.requiresAuth) {
      try {
        router.removeRoute(route.name);
      } catch (error) {
        console.warn(`移除路由 ${route.name} 失败:`, error);
      }
    }
  });
} 
